import moment from "moment";

export const NOTIFICATION_GROUP_TYPES = {
  TODAY: "Today",
  YESTERDAY: "Yesterday",
};

export const groupNotificationsByDate = (notifications) => {
  if (!Array.isArray(notifications) || notifications.length === 0) {
    return { [NOTIFICATION_GROUP_TYPES.TODAY]: [], [NOTIFICATION_GROUP_TYPES.YESTERDAY]: {}, older: {} };
  }

  const grouped = {
    [NOTIFICATION_GROUP_TYPES.TODAY]: [],
    [NOTIFICATION_GROUP_TYPES.YESTERDAY]: [],
    older: {},
  };

  const today = moment().startOf("day");
  const yesterday = moment().subtract(1, "day").startOf("day");

  notifications.forEach((notification) => {
    if (!notification?.createdAt) {
      return;
    }

    const notificationDate = moment(notification.createdAt);
    const dateKey = notificationDate.format("DD MMMM YYYY");
    const dayStart = notificationDate.clone().startOf("day");

    if (dayStart.isSame(today, "day")) {
      grouped[NOTIFICATION_GROUP_TYPES.TODAY].push(notification);
    } else if (dayStart.isSame(yesterday, "day")) {
      grouped[NOTIFICATION_GROUP_TYPES.YESTERDAY].push(notification);
    } else {
      if (!grouped.older[dateKey]) {
        grouped.older[dateKey] = [];
      }
      grouped.older[dateKey].push(notification);
    }
  });

  grouped[NOTIFICATION_GROUP_TYPES.TODAY].sort(
    (a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
  );
  grouped[NOTIFICATION_GROUP_TYPES.YESTERDAY].sort(
    (a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
  );

  Object.keys(grouped.older).forEach((dateKey) => {
    grouped.older[dateKey].sort(
      (a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
    );
  });

  return grouped;
};

export const formatDate = (date, format = "DD MMMM YYYY") => {
  if (!date) {
    return "";
  }
  return moment(date).format(format);
};

export const formatTime = (date) => {
  if (!date) {
    return "";
  }
  return moment(date).format("HH:mm");
};

export const sortNotificationsByTime = (notifications) => {
  if (!Array.isArray(notifications)) {
    return [];
  }
  return notifications.sort((a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf());
};

export const getUnreadCount = (notifications) => {
  if (!Array.isArray(notifications)) {
    return 0;
  }
  return notifications.filter((n) => !n.isRead).length;
};